import { COMMUNITY_ID, END_DATE, START_DATE, SECOND_USER_ID } from "./consts";
import { z } from "zod";

export const swapBomSchema = z.object({
  [SECOND_USER_ID]: z.string().min(1, "User is required"),
  [START_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    }),
  [END_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    })
    .optional(),
  [COMMUNITY_ID]: z.string().optional(),
});

export type swapBomFormValues = z.infer<typeof swapBomSchema>;
